import { useSelector } from 'src/hooks/useSelector';
import { ClusterKey, SearchClusterMap } from 'src/types/search/common/clusters';

import { useDraftClustersLogic } from 'src/components/Search/Common/Filters/hooks/draft/useDraftClustersLogic';

type UseSearchClusterState = <F extends ClusterKey>(filter: F) => SearchClusterMap[F];

export const useSearchClusterState: UseSearchClusterState = (filter) => {
    const cluster = useSelector((state) => state.searchClusters[filter]);
    const clusterDraft = useSelector((state) => state.searchDraftClusters[filter]);

    const isDraftClustersLogic = useDraftClustersLogic();

    return isDraftClustersLogic ? clusterDraft : cluster;
};

type UseSearchClusterOrderState = <F extends ClusterKey>(filter: F) => string[];

export const useSearchClusterOrderState: UseSearchClusterOrderState = (filter) => {
    const clusterOrder = useSelector((state) => state.searchClustersOrder[filter]);
    const clusterOrderDraft = useSelector((state) => state.searchDraftClustersOrder[filter]);

    const isDraftClustersLogic = useDraftClustersLogic();

    return isDraftClustersLogic ? clusterOrderDraft : clusterOrder;
};
